import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { hecsGuideZh } from "../../content/zh/hecs-repayment-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/hecs-repayment-calculator"

/** Chinese version of /hecs-repayment-calculator (D-WEB-LANG-SCOPE, T1320); the English route carries the hreflang pair too. */
export const hecsZhSeo = () => guideSeo(hecsGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/hecs-repayment-calculator")({
  head: () => {
    const { meta, links, scripts } = hecsZhSeo()
    return { meta, links, scripts }
  },
  component: HecsZhPage,
})

export function HecsZhPage() {
  return <GuidePage guide={hecsGuideZh} />
}
